/**
 * Schema version of the persisted domain model.
 *
 * Bumped whenever the shape of stored data changes. Backup files carry this
 * value (T-502) so that import can migrate older data forward and refuse
 * anything written by a newer version rather than guessing at it.
 */
export const SCHEMA_VERSION = 1

/**
 * The release version of the whole application, not only this package.
 *
 * Surfaced in exports and the report footer so a generated document can be
 * traced to what produced it, and shown on the Settings screen. The four
 * `package.json` files are expected to carry the same string; `pnpm
 * check:versions` fails the build when they drift, because four files nobody
 * reads plus one that ships inside a document is exactly the shape that does.
 *
 * Bumped as work lands — see `CHANGELOG.md` for what each one contained.
 */
export const CORE_VERSION = '0.1.0'
